<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-form-item label="用户名">
      <el-input v-model="queryParam.username" placeholder="用户名" />
    </el-form-item>
    <el-form-item label="昵称">
      <el-input v-model="queryParam.nickname" placeholder="昵称" />
    </el-form-item>
    <el-form-item label="部门">
      <el-tree-select
        placeholder="请选择部门"
        style="width: 100%"
        :data="departData"
        v-model="queryParam.departid"
        check-strictly
        :default-expand-all="true"
        :render-after-expand="false"
        :props="propsDepart"
      />
    </el-form-item>
    <el-form-item label="状态">
      <el-select v-model="queryParam.status" placeholder="用户状态">
        <el-option label="正常" :value="1" />
        <el-option label="停用" :value="2" />
      </el-select>
    </el-form-item>
    <el-form-item label="创建时间">
      <el-date-picker
        v-model="created"
        type="daterange"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        range-separator="-"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        @blur="changeCreated"
      />
    </el-form-item>

    <el-form-item>
      <el-button type="danger" @click="getListUser">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <el-button
          type="danger"
          @click="(dialog = true), doUserAdd()"
          v-hasPermission="['system:user:add']"
          >添加用户</el-button
        >
      </div>
    </el-col>
  </el-row>

  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table ref="tableRef" v-loading="loadingData" :data="tableData" class="mainTable">
        <el-table-column prop="username" label="用户名" />
        <el-table-column prop="nickname" label="昵称" />
        <el-table-column prop="phone" label="手机号" />
        <el-table-column prop="departname" label="部门" />
        <el-table-column prop="sex" label="性别">
          <template #default="scope">
            <el-tag
              round
              :type="scope.row.sex === 1 ? '' : 'danger'"
              disable-transitions
              ><span v-text="util.showSex(scope.row.sex)"></span
            ></el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="status" label="状态">
          <template #default="scope">
            <el-tag
              round
              :type="scope.row.status === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span v-text="util.showCommonStatus(scope.row.status)"></span>
            </el-tag>
            <el-switch
              :model-value="scope.row.status"
              v-hasPermission="['system:user:edit']"
              :active-value="1"
              :inactive-value="2"
              size="small"
              @change="doUserStatus(scope.$index, scope.row, 'status')"
            />
          </template>
        </el-table-column>

        <el-table-column prop="logined" label="登录日期" width="180">
          <template #default="scope">
            <span
              v-text="
                util.formatDateUnix(scope.row.logined, 'yyyy-MM-dd hh:mm')
              "
            ></span>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" width="160">
          <template #default="scope">
            <el-link
              type="primary"
              size="small"
              @click="(dialog = true), doUserEdit(scope.$index, scope.row)"
              v-hasPermission="['system:user:edit']"
              >编辑</el-link
            >

            <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要删除吗？"
              width="200px"
              @confirm="doUserStatus(scope.$index, scope.row, 'delflag')"
            >
              <template #reference>
                <el-link
                  size="small"
                  type="danger"
                  v-hasPermission="['system:user:delete']"
                  >删除</el-link
                >
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8">
      <!-- <div>
        <el-button type="danger">添加用户</el-button>
      </div> -->
    </el-col>
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          :hide-on-single-page="false"
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[10, 15, 20, 30]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :title="title"
    direction="rtl"
    :close-on-click-modal="false"
    size="45%"
    @close="doUserClose()"
  >
    <div class="common-drawer__content">
      <el-form
        ref="userFormRef"
        :model="userForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="用户名" prop="username">
          <el-input
            v-model.trim="userForm.username"
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="nickname">
          <el-input
            v-model.trim="userForm.nickname"
            placeholder="请输入昵称"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model.number="userForm.phone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="userForm.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="部门" prop="departid">
          <el-tree-select
            placeholder="请选择部门"
            style="width: 100%"
            :data="departData"
            v-model="userForm.departid"
            check-strictly
            :default-expand-all="true"
            :render-after-expand="false"
            :props="propsDepart"
            @node-click="selectDepart"
          />
        </el-form-item>
        <el-form-item label="岗位" prop="positionid">
          <el-select
            v-model="defPosition"
            multiple
            placeholder="请选择岗位，可多选"
            style="width: 100%"
            @change="selectPosition"
          >
            <el-option
              v-for="item in positionData"
              :key="item.positionid"
              :label="item.name"
              :value="`${item.positionid},${item.name}`"
            />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="岗位" prop="positionid">
          <el-select
            v-model="defPosition"
            multiple
            placeholder="请选择岗位，可多选"
            style="width: 100%"
            @change="selectPosition"
          >
            <el-option
              v-for="item in positionData"
              :key="item.positionid"
              :label="item.name"
              :value="{ value: item.positionid, label: item.name }"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="角色组" prop="groupid">
          <el-select
            v-model="defGroup"
            multiple
            placeholder="请选择角色组，可多选"
            style="width: 100%"
            @change="selectGroup"
          >
            <el-option
              v-for="item in groupData"
              :key="item.groupid"
              :label="item.name"
              :value="`${item.groupid},${item.name}`"
            />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="角色组" prop="groupid">
          <el-select
            v-model="defGroup"
            multiple
            placeholder="请选择角色组，可多选"
            style="width: 100%"
            @change="selectGroup"
          >
            <el-option
              v-for="item in groupData"
              :key="item.groupid"
              :label="item.name"
              :value="{ value: item.groupid, label: item.name }"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item
          label="密码"
          v-if="userForm.userid === null"
          prop="password"
        >
          <el-input
            v-model.trim="userForm.password"
            type="password"
            show-password
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="确认密码"
          v-if="userForm.userid === null"
          prop="confirmPassword"
        >
          <el-input
            v-model.trim="userForm.confirmPassword"
            type="password"
            show-password
            placeholder="请输入确认密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doUserClose()">关闭</el-button>
        <el-button type="danger" :loading="loading" @click="doUserSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listUser, changeUserStatus, saveUser } from "@/api/user";
import { listDepart } from "@/api/depart";
import { listPosition } from "@/api/position";
import { listGroup } from "@/api/group";
import util from "@/util/tool.js";

let timer;

const dialog = ref(false);
const loading = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const tableData = ref();
const total = ref(0);
const pageSize = ref(15); //每页显示条数

let userFormRef = ref();
let title = ref("新增用户");

// const defaultSelectDepart = ref([])

//onMounted方法
onMounted(() => {
  getListUser();
  getListDepart();
  getListPosition();
  getListGroup();
});

//时间区间搜索
let created = ref();
const changeCreated = () => {
  queryParam.value.created = Date.parse(created.value[0] + " 00:00:00");
  queryParam.value.changed = Date.parse(created.value[1] + " 23:59:59");
  //console.log('date range----', (created.value[0]), Date.parse(created.value[1]))
};

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  departid: "",
  status: "",
  created: "",
  changed: "",
  username: "",
  nickname: "",
});
const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    departid: "",
    status: "",
    created: "",
    changed: "",
    username: "",
    nickname: "",
  };
  getListUser();
};

//用户表单项
let userForm = ref({
  userid: null,
  username: "",
  nickname: "",
  phone: "",
  sex: "",
  password: "",
  confirmPassword: "",
  departid: "",
  departname: "",
  positionid: "",
  positionname: "",
  groupid: "",
  groupname: "",
});

//添加用户
const doUserAdd = () => {
  title.value = "新增用户";
  defPosition.value = [];
  defGroup.value = [];
  // console.log('add',userForm.value)
  resetForm();
};

//编辑用户
const doUserEdit = (index, obj) => {
  title.value = "编辑用户";
  // userForm.value = obj

  // defaultSelectDepart.value.push('773521992010969088')
  // defaultSelectDepart.value.push('运营部')

  // console.log('defaultSelectDepart.value:',defaultSelectDepart.value)

  if (obj.positionid && typeof obj.positionid != "undefined") {
    let positionid = obj.positionid.split(",");
    let positionname = obj.positionname.split(",");

    let tmpData = [];
    let i = 0;
    positionid.forEach((item) => {
      tmpData.push({ label: positionname[i], value: item });
      i++;
    });
    defPosition.value = tmpData;
  } else {
    defPosition.value = [];
  }
  if (obj.groupid && typeof obj.groupid != "undefined") {
    let groupid = obj.groupid.split(",");
    let groupname = obj.groupname.split(",");

    let tmpData = [];
    let i = 0;
    groupid.forEach((item) => {
      tmpData.push({ label: groupname[i], value: item });
      i++;
    });
    defGroup.value = tmpData;
  } else {
    defGroup.value = [];
  }

  userForm.value = {
    userid: obj.userid,
    username: obj.username,
    nickname: obj.nickname,
    phone: obj.phone,
    sex: obj.sex,
    departid: obj.departid ? obj.departid.toString() : null,
    departname: obj.departname,
    positionid: obj.positionid,
    positionname: obj.positionname,
    groupid: obj.groupid,
    groupname: obj.groupname,
  };
  console.log(userForm.value)
};
const resetForm = () => {
  userForm.value = {
    userid: null,
    username: "",
    nickname: "",
    delflag: "",
    phone: "",
    sex: "",
    password: "",
    confirmPassword: "",
    departid: "",
    departname: "",
    positionid: "",
    positionname: "",
    groupid: "",
    groupname: "",
  };
};

//关闭用户表单弹窗
const doUserClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  userFormRef.value.resetFields()
};

//保存用户数据
const doUserSave = () => {
  userFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }
    delete userForm.value.confirmPassword;

    saveUser(userForm.value).then((res) => {
      if (!userForm.value.userid) {
        userForm.value.confirmPassword = userForm.value.password;
      }
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListUser();
          doUserClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//关闭用户表单弹出框
// const doDrawerClose = (done) => {
//   if (loading.value) {
//     return;
//   }
//   ElMessageBox.confirm("您确定要提交表单数据吗？", {
//     distinguishCancelAndClose: true,
//     confirmButtonText: "确定提交",
//     confirmButtonClass: "el-button--danger",
//     cancelButtonText: "取消",
//   })
//     .then(() => {
//       loading.value = true;
//       timer = setTimeout(() => {
//         done();
//         // 动画关闭需要一定的时间
//         setTimeout(() => {
//           loading.value = false;
//         }, 400);
//       }, 1000);
//     })
//     .catch(() => {
//       // catch error
//     });
// };

//更新用户状态
const doUserStatus = (index, obj, flag) => {
  // console.log('obj.userid',obj.userid.toString())
  let data = {};
  if (flag === "delflag") {
    let delflag = obj.delflag == 1 ? 2 : 1;
    data = { delflag, userid: obj.userid.toString() };
    tableData.value.splice(index, 1);
  } else {
    let status = obj.status == 1 ? 2 : 1;
    data = { status, userid: obj.userid.toString() };
    // console.log("status", status);
    tableData.value[index].status = status;
  }
  changeUserStatus(data);
};

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListUser();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListUser();
};

//用户列表API
const getListUser = () => {
  listUser(queryParam.value).then((res) => {
    tableData.value = res.data.extend.pages.list;
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    loadingData.value = false
  });
};

//部门表API
const selectDepart = (v1) => {
  userForm.value.departname = v1.name;
};
const propsDepart = ref({
  checkStrictly: true,
  value: "departid",
  label: "name",
});
const departReset = (departs) => {
  let dataTmp = [];
  departs.forEach((depart) => {
    // console.log(depart);
    depart.departid = depart.departid.toString();
    depart.parentid = depart.parentid.toString();
    dataTmp.push(depart);
    departReset(depart.children);
  });
  return dataTmp;
};
const departData = ref([]);
const getListDepart = () => {
  listDepart({ pageNo: 1, pageSize: 500, status: 1 }).then((res) => {
    departData.value = departReset(res.data.extend.pages.list);
  });
};

//岗位表API
const defPosition = ref();
const selectPosition = (positions) => {
  //修订错误，再编辑时候不能重新选择
  let tmpData = [];
  positions.forEach((item) => {
      if (item.value) {
        tmpData.push(item.value + ','+item.label);
      } else {
        tmpData.push(item);
      }
  });

  let positionid = [];
  let positionname = [];
  tmpData.forEach((position) => {
    let tmp = position.split(',')
    positionid.push(tmp[0]);
    positionname.push(tmp[1]);
    // positionid.push(position.value.toString());
    // positionname.push(position.label);
  });
  userForm.value.positionid = positionid.join(",");
  userForm.value.positionname = positionname.join(",");
  // console.log(positionid.join(","), positionname.join(","));
};
const positionReset = (positions) => {
  let dataTmp = [];
  positions.forEach((position) => {
    // console.log(position);
    position.positionid = position.positionid.toString();
    dataTmp.push(position);
  });
  return dataTmp;
};
const positionData = ref([]);
const getListPosition = () => {
  listPosition({ pageNo: 1, pageSize: 500, status: 1 }).then((res) => {
    positionData.value = positionReset(res.data.extend.pages.list);
  });
};

//角色组API
const defGroup = ref();
const selectGroup = (groups) => {
  //修订错误，再编辑时候不能重新选择
  let tmpData = [];
  groups.forEach((item) => {
      if (item.value) {
        tmpData.push(item.value + ','+item.label);
      } else {
        tmpData.push(item);
      }
  });

  let groupid = [];
  let groupname = [];
  tmpData.forEach((group) => {
    let tmp = group.split(',')
    groupid.push(tmp[0]);
    groupname.push(tmp[1]);
    // groupid.push(group.value.toString());
    // groupname.push(group.label);
  });
  userForm.value.groupid = groupid.join(",");
  userForm.value.groupname = groupname.join(",");
  // console.log(groupid.join(","), groupname.join(","));
};
const groupReset = (groups) => {
  let dataTmp = [];
  groups.forEach((group) => {
    // console.log(group);
    group.groupid = group.groupid.toString();
    dataTmp.push(group);
  });
  return dataTmp;
};
const groupData = ref([]);
const getListGroup = () => {
  listGroup({ pageNo: 1, pageSize: 500, status: 1 }).then((res) => {
    groupData.value = groupReset(res.data.extend.pages.list);
  });
};

//密码验证规则
const validatePass = (rule, value, callback) => {
  //  密码只能由大小写英文字母或数字开头，且由大小写英文字母_.组成
  const reg =
    /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,16}$/;
  if (!value.match(reg)) {
    callback(
      new Error("密码长度不小于8位，必须包含大写、小写数字、字符中至少3种")
    );
  } else {
    callback();
  }
};
const validatePass2 = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入确认密码"));
  } else if (value !== userForm.value.password) {
    callback(new Error("两次输入的密码不一致"));
  } else {
    callback();
  }
};

//用户表单验证规则
const rules = ref({
  username: [
    {
      required: true,
      message: "请输入用户名",
      trigger: "blur",
    },
    {
      min: 3,
      max: 10,
      message: "用户名长度3到10",
      trigger: "blur",
    },
  ],
  nickname: [
    {
      required: true,
      message: "请输入昵称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 10,
      message: "昵称长度2到10",
      trigger: "blur",
    },
  ],
  phone: [
    {
      required: true,
      message: "请输入手机号",
      trigger: "blur",
    },
    {
      pattern: /^1[3456789]\d{9}$/,
      message: "手机号码格式不正确",
      trigger: "blur",
    },
  ],
  password: [
    { required: true, message: "密码不能为空", trigger: "blur" },
    { min: 8, max: 16, message: "密码位数只能在8~16之间", trigger: "blur" },
    { required: true, validator: validatePass, trigger: "blur" },
  ],
  confirmPassword: [
    { required: true, message: "密码不能为空", trigger: "blur" },
    { min: 8, max: 16, message: "密码位数只能在8~16之间", trigger: "blur" },
    { required: true, validator: validatePass2, trigger: "blur" },
  ],
});

// const showSex = (sex)=>{
//   if (sex===1) {return '男'}
//   return '女'
// }

// const showDelflag = (flag)=>{
//   if (flag===1) {return '正常'}
//   return '已删除'
// }

// const showUserStatus = (status)=>{
//   if (status===1) {return '正常'}
//   return '屏蔽'
// }
</script>
